<script>
  import { getPlatforms } from "@/services/platforms";

  export default {
    components: {
      FiltersBarInLive: () => import("./FiltersBarInLive.vue"),
      CardStatisticAvailable: () => import("./CardStatisticAvailable.vue"),
      CardStatisticByPlatform: () => import("./CardStatisticByPlatform.vue"),
      CardStatisticBusyBar: () => import("./CardStatisticBusyBar.vue"),
    },
    data() {
      return {
        msg: "porcentaje de ocupación global",
        showPlatforms: true,
        isCollapseClosing: {},
        key: 0,
        isLoaded: true,
        collapsedCitiesInfo: [],
        availableOptions: [
          { text: "Disponibilidad", value: "" },
          { text: "Disponible", value: "disponibles" },
          { text: "Ocupadas", value: "ocupadas" },
          { text: "Deshabilitada", value: "deshabilitadas" },
        ],
        satelites: [],
        platformsData: [],
        directoryUsers: [],
        rooms: [],
      };
    },
    computed: {
      userPlatformType() {
        return this.$store?.state?.user?.profile?.platformType || [];
      },
      userRole() {
        return this.$store?.state?.user?.profile?.role || "";
      },
      usersConnected() {
        return this.$store.getters["connectedUsers/getModels"] || [];
      },
      allowDual() {
        const platforms = Array.isArray(this.userPlatformType) ? this.userPlatformType : [this.userPlatformType];
        const roles = ["coordinator", "monitor"];

        if (this.userRole === "superadmin") {
          return true;
        }

        if (roles.includes(this.userRole)) {
          return platforms.includes("private");
        }

        return true;
      },
      allowDualFree() {
        const platforms = Array.isArray(this.userPlatformType) ? this.userPlatformType : [this.userPlatformType];

        if (this.userRole === "superadmin") {
          return true;
        }

        return platforms.includes("free");
      },
      roomsData() {
        return this.getRoomsFilteredWithModels(this.rooms);
      },
      totalModelsGlobal() {
        return this.directoryUsers.filter((model) => model.office === "Satelite");
      },
      totalsRooms() {
        const totals = {
          "modelos en línea": this.usersConnected.length,
          ocupadas: 0,
          disponibles: 0,
          deshabilitadas: 0,
          private: 0,
          free: 0,
          "free / Priv": 0,
          global: this.modelsGlobalConected.length,
        };
        this.roomsData.forEach((room) => {
          const hasModel = Boolean(room?.modelTemp?._id);
          const isEnabled = Boolean(room?.isEnable);
          const platforms = room?.platformType || [];

          if (!isEnabled) {
            totals.deshabilitadas++;
            return;
          }

          if (hasModel) {
            totals.ocupadas++;
          } else {
            totals.disponibles++;
            return;
          }

          const isFree = platforms.includes("free");
          const isPrivate = platforms.includes("private");

          if (isFree && isPrivate) {
            totals["free / Priv"]++;
          } else if (isFree && platforms.length === 1) {
            totals.free++;
          } else if (isPrivate && platforms.length === 1) {
            totals.private++;
          }
        });

        const result = {
          ocupadas: totals.ocupadas,
          disponibles: totals.disponibles,
          deshabilitadas: totals.deshabilitadas,
        };

        if (this.userRole === "superadmin") {
          return totals;
        }

        const userPlatforms = Array.isArray(this.userPlatformType) ? this.userPlatformType : [this.userPlatformType].filter(Boolean);

        if (userPlatforms.includes("free")) {
          result.free = totals.free;
        }

        if (userPlatforms.includes("private") || userPlatforms.includes("free")) {
          result["free / Priv"] = totals["free / Priv"];
        }

        if (userPlatforms.includes("group")) {
          result.grupal = totals.grupal;
        }

        return { ...result, global: totals.global };
      },
      avgBusy() {
        return this.roomsData.length === 0 ? 0 : Math.round((this.totalsRooms.ocupadas / (this.roomsData.length - this.totalsRooms.deshabilitadas)) * 100);
      },
      modelsGlobalConected() {
        return this.roomsWithGlobalData.filter((model) => model.cityName === "Global" && typeof model.modelTemp !== "undefined");
      },
      avergareGlobal() {
        const { totalModelsGlobal, modelsGlobalConected } = this;
        if (totalModelsGlobal.length === 0) {
          return 0;
        }
        const average = Math.round((modelsGlobalConected.length / totalModelsGlobal.length) * 100);
        return average;
      },
      roomsWithGlobalData() {
        const roomBasic = {
          isEnable: true,
          cityName: "Global",
          officeName: "Satelite",
        };
        const sateliteRooms = this.satelites.map(({ artisticName, user }) => ({ _id: user, roomName: artisticName, ...roomBasic }));
        return this.getRoomsFilteredWithModels([...this.rooms, ...sateliteRooms]);
      },
      reducedData() {
        const defaultPlatforms = Object.fromEntries((this.platformsData || []).map((p) => [p.name.toLowerCase(), 0]));

        const data = (this.roomsWithGlobalData || []).reduce((acc, raw) => {
          if (!raw?.isEnable) {
            return acc;
          }

          const cityName = raw?.cityInfo?.cityName ?? raw?.cityName ?? raw?.city?.name ?? "Global";
          const officeName = raw?.officeName ?? raw?.office?.name ?? "Unknown";
          const modelTemp = raw?.modelTemp ?? raw?.model ?? null;

          const cityData = acc[cityName] || (acc[cityName] = {});
          const officeData =
            cityData[officeName] ||
            (cityData[officeName] = {
              platform: { ...defaultPlatforms },
              users: { total: 0, users: 0 },
              rooms: [],
            });

          const userPlatforms = this?.$user?.platformType || [];
          const isSuperAdmin = this?.$user?.role === "superadmin";

          if (!isSuperAdmin && userPlatforms.length > 0) {
            const modelPlatforms = modelTemp?.platformType || [];

            const sharePlatform = modelPlatforms.some((p) => userPlatforms.includes(p));

            if (modelTemp && !sharePlatform) {
              modelTemp.artisticName = "Ocupado";
              modelTemp.picture = "";
            }
          }

          if (modelTemp?.broadcastingPlatforms?.length) {
            for (const id of modelTemp.broadcastingPlatforms) {
              const plf = (this.platformsData || []).find((p) => p._id === id);
              if (!plf) continue;
              const key = plf.name.toLowerCase();
              officeData.platform[key] = (officeData.platform[key] ?? 0) + 1;
            }
          }

          if (modelTemp?._id) {
            officeData.users.users += 1;
          }

          officeData.users.total += 1;
          officeData.rooms.push(raw);
          return acc;
        }, {});

        Object.keys(data).forEach((city) => {
          Object.keys(data[city]).forEach((office) => {
            if (data[city][office].rooms.length === 0) {
              delete data[city][office];
            }
          });

          if (Object.keys(data[city]).length === 0) {
            delete data[city];
          }
        });

        return data;
      },
      roomsInOficces() {
        const data = this.roomsData.reduce((acc, item) => {
          const office = item.officeName;

          if (!acc?.[office]) {
            acc[office] = [];
          }

          acc[office].push(item);
          return acc;
        }, {});
        return data;
      },
    },
    methods: {
      async getRooms() {
        const { data } = await this.$axios.get("/rooms?all=true");
        this.rooms = data.rooms || [];
      },
      async getSatelites() {
        const { data } = await this.$axios.get(`/userslist?city=Global&role=model`);
        const { users, error } = data;
        this.satelites = users || [];
      },
      async loadDirectoryUsers() {
        try {
          const { data } = await this.$axios.get("/users");
          this.directoryUsers = Array.isArray(data?.users) ? data.users : [];
        } catch (error) {
          console.error("error loadDirectoryUsers :>> ", error);
          this.directoryUsers = [];
        }
      },
      closeCollapse() {
        if (this.$screen.width <= 430 && !this.collapsedCitiesInfo.length) {
          const executeReduce = (sede) => this.manageCityCollapse(sede);
          Object.values(this.reducedData).forEach((sedes) => {
            Object.keys(sedes).forEach(executeReduce);
          });
          this.isLoaded = false;
        }
      },
      getStatusRoom(room) {
        const model = room?.modelTemp || {};
        if (!room.isEnable) {
          return "disabled";
        } else if (model?.isBreak) {
          return "break";
        } else if (model?._id) {
          return "busy";
        }
      },
      getModel(room) {
        if (!room?.modelTemp?._id) {
          return null;
        }
        return room?.modelTemp;
      },
      /**
       * Esta funcion es la encargada de devolver una clase dependiendo del estado de la habitacion
       * y de la plataforma en la que la modelo este stremeando
       * @param {*} room informacion de la habitacion
       */
      getClassByStatus(room) {
        const roomStatus = this.getStatusRoom(room);
        if (roomStatus !== "busy") return roomStatus;

        const model = room?.modelTemp || {};
        const token = this.$route.query?.platform ? this.toValue(this.$route.query.platform) : null;

        if (token === "double" && this.allowDual) {
          const onJ = this.isModelOnPlatform(model, "jasmin");
          const onS = this.isModelOnPlatform(model, "streamate");
          return onJ && onS ? "bothPlatforms" : "busy";
        }

        if (token && this.isModelOnPlatform(model, token)) return token;

        return "busy";
      },
      showPlatformsToggle() {
        this.showPlatforms = !this.showPlatforms;
      },
      getStreamingPlatforms(model) {
        const ids = model?.broadcastingPlatforms || [];

        return ids
          .map((id) => {
            const p = this.platformsData.find((pl) => pl._id === id);
            return p ? p.name.toLowerCase().replace(/\s|_/g, "") : null;
          })
          .filter(Boolean);
      },
      nameInRoom(model, statusRoom, room) {
        const names = {
          disabled: () => "Deshabilitada",
          break: () => model?.artisticName,
          busy: () => model?.artisticName,
        };

        const nameReturn = () => this.removeBlanks(names?.[statusRoom]?.()) || "Disponible";
        const nameGlobal = () => (!model?.artisticName ? "Desconectada" : "");

        return room?.cityName === "Global" ? nameGlobal() : nameReturn();
      },
      getIconName(model) {
        return model?.isBreak ? "pause" : model?.isStreaming ? "play" : "";
      },
      removeBlanks(str) {
        return str?.replace(/\s+/g, "") || "";
      },

      getRoomsFilteredWithModels(rooms) {
        const roomsTest = structuredClone(rooms);
        const { query } = this.$route;

        const parseQueryList = (value) => {
          if (!value) return [];
          const list = Array.isArray(value) ? value : [value];
          return list
            .flatMap((entry) => String(entry).split(","))
            .map((entry) => entry.trim())
            .filter(Boolean);
        };

        const selectedCities = parseQueryList(query?.cities);
        const selectedOffices = parseQueryList(query?.offices);
        const normalizeName = (value) =>
          String(value || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .trim();
        const selectedCitiesNormalized = selectedCities.map(normalizeName);
        const selectedOfficesNormalized = selectedOffices.map(normalizeName);

        const toValue = (name = "") => name.toLowerCase().replace(/\s|_/g, "");
        const platformValueToId = {};
        this.platformsData.forEach((p) => {
          platformValueToId[toValue(p.name)] = p._id;
        });
        const chaturbateId = platformValueToId.chaturbate;
        const stripchatId = platformValueToId.stripchat;

        const filterSwichAvailable = {
          disponibles: (room) => room.isEnable && !room?.modelTemp?._id,
          deshabilitadas: (room) => !room.isEnable,
          ocupadas: (room) => !!room?.modelTemp?._id,
        };

        const filterSwichPlatform = {
          jasmin: (room) => room?.modelTemp?.isBroadcastingOnJasmin,
          streamate: (room) => room?.modelTemp?.isBroadcastingOnStreamate,
          double: (room) => room?.modelTemp?.isBroadcastingOnJasmin && room?.modelTemp?.isBroadcastingOnStreamate,
          dualfree: (room) => {
            if (!chaturbateId || !stripchatId) return false;
            const ids = room?.modelTemp?.broadcastingPlatforms || [];
            return ids.includes(chaturbateId) && ids.includes(stripchatId);
          },
          none: (room) => room?.modelTemp && !room?.modelTemp?.isBroadcastingOnJasmin && !room?.modelTemp?.isBroadcastingOnStreamate,
          __dynamic: (token) => {
            const id = platformValueToId[token];

            if (!id) return () => true;

            return (room) => {
              const ids = room?.modelTemp?.broadcastingPlatforms || [];
              return ids.includes(id);
            };
          },
        };

        if (!this.allowDual) {
          delete filterSwichPlatform.double;
        }
        if (!this.allowDualFree) {
          delete filterSwichPlatform.dualfree;
        }

        const roomsFiltered = roomsTest.filter((room) => {
          const roomCityName = normalizeName(room?.cityName || room?.cityInfo?.cityName || room?.city?.name);
          const roomOfficeName = normalizeName(room?.officeName || room?.office?.name || room?.office?.officeName);

          let locationMatch = true;

          if (selectedCitiesNormalized.length && selectedOfficesNormalized.length) {
            locationMatch = selectedCitiesNormalized.includes(roomCityName) || selectedOfficesNormalized.includes(roomOfficeName);
          } else if (selectedCitiesNormalized.length) {
            locationMatch = selectedCitiesNormalized.includes(roomCityName);
          } else if (selectedOfficesNormalized.length) {
            locationMatch = selectedOfficesNormalized.includes(roomOfficeName);
          }

          const isFilterRoom = query?.room ? query.room === room.roomName : true;

          return locationMatch && isFilterRoom;
        });

        const modelrooms = this.$store.getters["connectedUsers/getModelsInRoom"];
        const onlineUsersMap = this.$store.getters["connectedUsers/getUserMapIndex"] || {};
        const modelsMap = {};
        const directoryModelsMap = {};

        modelrooms.forEach((model) => model?.roomTemp?._id && (modelsMap[model.roomTemp._id] = model));
        (this.directoryUsers || []).forEach((user) => {
          const latestOnlineData = onlineUsersMap[user._id];
          const roomId = latestOnlineData?.roomTemp?._id || user?.roomTemp?._id;
          if (!roomId || modelsMap[roomId]) return;

          directoryModelsMap[roomId] = latestOnlineData ? { ...user, ...latestOnlineData } : user;
        });

        const roomsFilterBusy = roomsFiltered.filter((room) => {
          if (modelsMap[room._id]) {
            room.modelTemp = modelsMap[room._id];
          } else if (directoryModelsMap[room._id]) {
            room.modelTemp = directoryModelsMap[room._id];
          }

          const isFilterAvailable = query?.available ? (filterSwichAvailable?.[query.available] || (() => true))(room) : true;

          let isFilterPlatform = true;
          if (query?.platform) {
            const token = toValue(query.platform);
            const handler = filterSwichPlatform[token] || filterSwichPlatform.__dynamic(token);
            isFilterPlatform = handler(room);
          }

          return isFilterAvailable && isFilterPlatform;
        });

        return roomsFilterBusy;
      },
      showCleanBtn({ flag, platform }) {
        this.$refs.filterBarInLive.platform = flag ? platform : "";
        this.$refs.filterBarInLive.executeFilter("platform");
      },
      manageCityCollapse(cityIndex) {
        if (this.isCollapseClosing[cityIndex]) return;

        this.isCollapseClosing[cityIndex] = true;

        const findIndexCity = this.collapsedCitiesInfo.findIndex((city) => city === cityIndex);
        const fatherHeight = document.getElementById(`wrapper-${cityIndex}`).offsetHeight;
        if (findIndexCity != -1) this.collapsedCitiesInfo.splice(findIndexCity, 1);
        else {
          this.collapsedCitiesInfo.push(cityIndex);
        }
        this.toggleElementCollapse({
          fatherIdOrClass: `#container-${cityIndex}`,
          fatherHeight,
          isCollapseToClose: findIndexCity === -1,
          fatherHeightCollapsed: this.$screen.width <= 1024 ? 104 : 74,
          gapValue: 7.5,
          key: cityIndex,
        });
      },

      toggleElementCollapse(collapseInfo) {
        const { fatherIdOrClass, fatherHeight, isCollapseToClose, fatherHeightCollapsed, gapValue = 0, key } = collapseInfo;
        const interval = setInterval(() => {
          const fatherElement = document.querySelector(fatherIdOrClass);
          let currentFatherHeight = fatherElement.offsetHeight;
          if (isCollapseToClose) {
            const realFatherHeightCollapsed = fatherHeightCollapsed - gapValue;
            if (currentFatherHeight > realFatherHeightCollapsed) {
              fatherElement.style.height = `${currentFatherHeight - 5}px`;
            } else {
              this.isCollapseClosing[key] = false;
              fatherElement.style.height = realFatherHeightCollapsed + "px";
              clearInterval(interval);
            }
          } else {
            const realFatherHeightCollapsed = fatherHeightCollapsed + gapValue;
            if (currentFatherHeight <= fatherHeight) {
              fatherElement.style.height = currentFatherHeight + 5 + "px";
            } else {
              const resta = ["available", "platforms"].includes(key) ? 0 : realFatherHeightCollapsed;

              fatherElement.style.height = fatherHeight + resta + "px";
              this.isCollapseClosing[key] = false;
              clearInterval(interval);
            }
          }
        }, 1);
      },

      findIndexCity(index) {
        return this.collapsedCitiesInfo.some((city) => city == index);
      },
      async getPlatforms() {
        const { data = [] } = await getPlatforms({});

        this.platformsData = data;
      },
      toValue(name = "") {
        return String(name).toLowerCase().replace(/\s|_/g, "");
      },
      isModelOnPlatform(model, token) {
        if (!model) return false;

        const ids = model.broadcastingPlatforms || [];

        if (!ids.length || !this.platformsData?.length) return false;

        const pl = this.platformsData.find((p) => this.toValue(p.name) === this.toValue(token));
        return !!pl && ids.includes(pl._id);
      },
      getPlatformsCount(platforms) {
        return Object.entries(platforms).map(([name, val]) => ({ name, val }));
      },
    },
    async beforeMount() {
      await Promise.all([this.getPlatforms(), this.getSatelites(), this.loadDirectoryUsers(), this.getRooms()]);
    },
    watch: {
      $route() {
        this.key++;
      },
    },
  };
</script>

<template>
  <section class="occupationInLive" :key="key">
    <FiltersBarInLive ref="filterBarInLive" />
    <CardStatisticBusyBar :avgBusy="avgBusy" v-if="$screen.width <= 430" />
    <CardStatisticBusyBar :avgBusy="avergareGlobal" :msg="msg" v-if="$screen.width <= 430" />
    <div class="occupationInLive__statistics">
      <CardStatisticAvailable class="card__statistic" :totalsRooms="totalsRooms" :total="roomsData.length" @toggleElementCollapse="toggleElementCollapse" />
      <CardStatisticByPlatform
        class="card__statistic"
        :roomsData="roomsWithGlobalData"
        @showCleanBtn="showCleanBtn"
        @toggleElementCollapse="toggleElementCollapse"
        :showPlatformsToggle="showPlatformsToggle"
        :showPlatforms="showPlatforms"
        :platformsData="platformsData" />
    </div>
    <div class="occupationInLive__statistics">
      <CardStatisticBusyBar :avgBusy="avgBusy" v-if="$screen.width > 430" />
      <CardStatisticBusyBar :avgBusy="avergareGlobal" :msg="msg" v-if="$screen.width > 430" />
    </div>
    <div :class="['occupationInLive__cityCard']" v-for="(city, cityKey) in reducedData" :key="cityKey">
      <div class="occupationInLive__header">
        <h3 class="occupationInLive__title">{{ cityKey }}</h3>
      </div>
      <div class="occupationInLive__officeCards">
        <div :class="['occupationInLive__officeCard', 'collapse__container', { 'collapse-active': findIndexCity(key) }]" v-for="(office, key) in city" :key="key" :id="`container-${key}`">
          <div class="occupationInLive__officeHeader collapse__header" :id="`header-${key}`">
            <div class="occupationInLive__officeHeader--info">
              <div class="occupationInLive__officeData">
                <span class="occupationInLive__firstDetail">{{ key }}</span>
                <span class="occupationInLive__secDetail">{{ `${office.users.users} / ${office.users.total}` }}</span>
              </div>
              <div class="occupationInLive__officeData occupationInLive__officeData--platformData">
                <div class="occupationInLive__counts" v-for="item in getPlatformsCount(office.platform)" :key="item.name">
                  <div class="occupationInLive__contentIcon">
                    <iconic :class="`occupationInLive__roomCardIcon occupationInLive__roomCardIcon--${item.name}`" :name="'play'" v-if="item.name !== 'chaturbate'" />
                    <div class="occupationInLive__shape" v-else />
                  </div>
                  <span>{{ item.val }}</span>
                </div>
              </div>
              <button class="collapse__button" type="button" @click="manageCityCollapse(key)"><iconic name="chevronUp" /></button>
            </div>
          </div>

          <div class="occupationInLive__contentRooms collapse__body" :id="`wrapper-${key}`">
            <div
              :class="`occupationInLive__cardInLive occupationInLive__cardInLive--${getClassByStatus(room)}`"
              v-for="room in office.rooms"
              :set="((model = getModel(room)), (statusRoom = getStatusRoom(room)), (iconName = getIconName(model)))"
              :key="room._id">
              <div class="occupationInLive__roomCardAvatarContainer" v-if="model">
                <template v-if="false">
                  <iconic
                    :class="`occupationInLive__iconPlatform occupationInLive__iconPlatform--streamate occupationInLive__iconPlatform--${model.isBroadcastingOnStreamate ? 'isInPlatform' : ''}`"
                    name="streamate"
                    v-if="model.jasminUser" />
                  <iconic
                    :class="`occupationInLive__iconPlatform occupationInLive__iconPlatform--jasmin occupationInLive__iconPlatform--${model.isBroadcastingOnJasmin ? 'isInPlatform' : ''}`"
                    name="jasmin"
                    v-if="model.streamateUser" />
                </template>
                <Avatar class="occupationInLive__roomCardAvatar" :user="model" />
              </div>
              <div :class="`occupationInLive__roomCardInfo occupationInLive__roomCardInfo--${model ? 'busy' : ''}`">
                <span>{{ nameInRoom(model, statusRoom, room) }}</span>
                <div :class="`occupationInLive__contentItem occupationInLive__contentItem--${model ? 'busy' : ''}`">
                  <span :class="`occupationInLive__roomName occupationInLive__roomName--${getClassByStatus(room)}`">{{ room.roomName }}</span>
                  <div class="occupationInLive__platforms" v-if="getStreamingPlatforms(model).length">
                    <div class="occupationInLive__roomCardIcons" v-for="(platform, index) in getStreamingPlatforms(model)" :key="index">
                      <iconic :class="`occupationInLive__roomCardIcon occupationInLive__roomCardIcon--${platform}`" :name="'play'" v-if="platform !== 'chaturbate'" />
                      <div class="occupationInLive__shape" v-else />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
  .occupationInLive {
    $iconSize: 22px;
    $overlap: 11px;

    @include Flex(column, flex-start);
    width: 100%;
    max-width: $tv_width;
    gap: $mpadding;
    margin-bottom: 50px;
    .collapse__container {
      .collapse__header {
        position: relative;
        z-index: 10;
      }
      .collapse__button {
        all: unset;
        display: flex;
        cursor: pointer;
        transition: transform 0.3s ease-in-out;
        grid-column: 2;
        grid-row: 1;
        width: fit-content;
        justify-self: end;
        .iconic {
          font-size: 22px;
        }
      }

      &.collapse-active {
        overflow: hidden;
        .collapse__button {
          transform: rotate(180deg);
        }
      }
    }

    &__header {
      display: flex;
      @include Flex(row, space-between, center);
      width: 100%;
      padding: 15px;
    }
    &__statistics {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;
      width: 100%;
      gap: 15px;
    }
    &__cityCard {
      width: 100%;
      background: white;
      box-shadow: 0px 1px 4px 0px #00000040;
      border-radius: 8px;
    }
    &__title {
      font-weight: lighter;
    }
    &__officeCards {
      padding: 9px;
    }
    &__officeCard {
      @include Flex(column, flex-start, flex-start);
      position: relative;
      gap: $mpadding / 2;
      width: 100%;
      margin-bottom: $mpadding/2;
      padding: 10px 12px;
      background: #f2f2f2;
      border-radius: 9px;
    }
    &__officeHeader {
      width: 100%;
      padding: 10px 0;

      &--info {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 10px;
      }
      .collapse__button {
        justify-self: flex-end;
      }
    }
    &__officeData {
      @include Flex(row);
      max-width: 160px;

      height: 25px;
      padding: 0 8px;
      font-family: $sec-font;
      font-size: 20px;
      color: #fff;
      background: $primary-color;
      border-radius: 9px;
      &--platformData {
        background: white;
        border: 2px solid black;
        color: #000;
        padding: 12px;
        overflow: hidden;
        grid-column: 1 / -1;
        grid-row: 2;
        max-width: 248px;
        :last-child {
          border: none;
        }
      }
    }
    &__firstDetail {
      @include Flex(row);
      padding: 0 10px;
      gap: 7px;
    }
    &__secDetail {
      position: relative;
      @include Flex(row);
      white-space: nowrap;
      gap: 7px;
      padding: 0 10px;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 1px;
        height: 65%;
        background-color: #fff;
      }
    }
    &__counts {
      @include Flex(row);
      padding: 0 10px;
      gap: 7px;
      border-right: 2px solid #000;
    }
    &__contentIcon {
      @include Flex(row);
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #fff;
    }
    &__iconPlatformOffice {
      font-size: 18px;
      &--jasmin {
        color: #bd0909;
      }
      &--streamate {
        color: #21619a;
      }
    }
    &__contentRooms {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      width: 100%;
      gap: $mpadding / 2;
    }
    &__cardInLive {
      @include Flex(row);
      gap: 5px;
      padding: 8px;
      text-transform: capitalize;
      background: rgba(32, 158, 12, 0.05);
      border: 2px solid #209e0c;
      border-radius: 7px;
      transition: 0.5s ease-in-out;
      &--disabled {
        background: rgba(157, 157, 157, 0.24);
        border-color: #9d9d9d;
      }
      &--busy {
        background: rgba(189, 9, 9, 0.05);
        border-color: #bd0909;
      }
      &--break {
        background: rgba(238, 187, 4, 0.09);
        border-color: #eebb04;
      }
      &--bothPlatforms {
        background: rgb(251, 245, 253);
        border-color: rgb(161, 85, 185);
      }
      &--jasmin {
        background: rgba(189, 9, 9, 0.05);
        border-color: #bd0909;
      }
      &--streamate {
        background: #21619a17;
        border-color: #21619a;
      }
    }
    &__roomCardInfo {
      @include Flex(column);
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #000;
      &--busy {
        width: calc(100% - 45px);
        align-items: flex-start;
      }
    }
    &__contentItem {
      @include Flex(row);
      width: 100%;
      transition: 0.5s ease-in-out;
      &--busy {
        justify-content: space-between;
      }
    }
    &__roomName {
      font-weight: 600;
      color: #209e0c;
      transition: 0.5s ease-in-out;
      max-width: 95%;
      text-overflow: ellipsis;
      overflow: hidden;
      &--disabled {
        color: black;
      }
      &--busy {
        color: $primary-color;
      }
      &--break {
        color: #eebb04;
      }
      &--bothPlatforms {
        color: #a155b9;
      }
      &--jasmin {
        color: #bd0909;
      }
      &--streamate {
        color: #21619a;
      }
    }
    &__platforms {
      display: flex;
      align-items: center;
      position: relative;
      min-height: $iconSize;
      overflow: visible;
      gap: 0;
    }

    &__roomCardIcons {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: $iconSize;
      height: $iconSize;

      &:not(:first-child) {
        margin-left: -$overlap;
      }

      z-index: 0;
    }
    &__roomCardIcons:nth-child(n) {
      z-index: 4;
    }
    &__roomCardIcons:nth-child(n + 2) {
      z-index: 3;
    }
    &__roomCardIcons:nth-child(n + 3) {
      z-index: 2;
    }
    &__roomCardIcons:nth-child(n + 4) {
      z-index: 1;
    }

    &__roomCardIcons .iconic,
    &__roomCardIcons .iconic svg {
      font-size: 22px;
    }

    .occupationInLive__roomCardIcon {
      &--livejasmin {
        color: #d50101;
      }
      &--streamate {
        color: #21619a;
      }
      &--stripchat {
        color: #7f19ad;
      }
    }

    &__roomCardAvatarContainer {
      position: relative;
      @include Flex(row);
    }
    &__roomCardAvatar {
      width: 35px;
      height: 35px;
      border: 1px solid $white;
    }

    &__shape {
      width: 24px;
      height: 24px;
      background: linear-gradient(153deg, #f37322 4.79%, #ffd67d 81.79%);

      -webkit-mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path d='M20,12 A8,8 0 0 0 12,20 V80 A8,8 0 0 0 20,88 L68,60 Q92,50 68,40 Z' fill='black'/></svg>")
        center/100% 100% no-repeat;
      mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path d='M20,12 A8,8 0 0 0 12,20 V80 A8,8 0 0 0 20,88 L68,60 Q92,50 68,40 Z' fill='black'/></svg>")
        center/100% 100% no-repeat;
    }

    @media screen and (min-width: $tablet-width) {
      &__contentRooms {
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        padding: $mpadding / 2;
        gap: $mpadding / 1.3;
      }
      &__officeCards {
        padding: 15px;
      }
      &__officeHeader {
        padding: 15px;
      }
    }

    @media screen and (min-width: 1024px) {
      &__officeHeader {
        &--info {
          @include Flex(row, center);
          display: flex;
        }
      }

      &__officeData {
        &--platformData {
          grid-column: 2;
          grid-row: 1;
        }
      }

      &__statistics {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
      }

      .collapse__container {
        .collapse__button {
          margin-left: auto;
        }
      }
    }
  }
</style>
